// 通用工具:测距、测面、鼠标位置、添加百度街景图层、实时交通图层
const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    // 属性
    options: {
        map: null,
        bdPanoCtrl: null,
        panoCoverageLayer : null,
        trfficLayer: null,
        config: null,
    },

    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
        //
        this._initMeasure(this.map); // 测量工具
    },
    //  销毁
    destroy() {
        componentBase.prototype.destroy.call(this);
    },

    load() {
        componentBase.prototype.load.call(this);
        //
    },

    addListeners() {
        //
    },

    removeListeners() {
    },

    unload() {
        componentBase.prototype.unload.call(this);
    },



    measureLength() {
        // 距离测量
        this.measureComponent.measureLength();
    },

    measureArea() {
        // 面积面积
        this.measureComponent.measureArea();
    },

    cancelMeasure() {
        // 取消测量
        this.measureComponent.cancel();
    },

    clearMeasure() {
        this.measureComponent.clear();
    },


    _initMeasure(map: any) {
        const lengthTipFn: any = (type: any, length: any) => {
            if (!isNaN(length)) {
                length = (length / 1000).toFixed(2);
            }
            const createHtmlFn: any = {
                // 起点
                start() {
                    return '起点';
                },
                // 中间点
                node(length1: any) {
                    return length1 + '公里';
                },
                // 终点
                end(length1: any) {
                    return '总长:' + length1 + '公里';
                },
            };
            const fn = createHtmlFn[type];
            if (Object.prototype.toString.call(fn) === '[object Function]') {
                return createHtmlFn[(type)](length);
            }
        };
        // 测面积的显示内容，需返回要显示的html字符串
        const areaTipFn: any = (length: any, area: any) => {
            length = (length / 1000).toFixed(2);
            area = (area / 1000000).toFixed(2);
            return '周长:' + length + '公里 <br/>面积:' + area + '平方公里';
            console.debug('>> 测量面积');
        };

        // 预先创建测量图层-可选
        const measureLayerId: string = 'measure-layer';
        // 测量组件
        this.measureComponent = new G.common.Measure({
            layerId: measureLayerId,
            map,
            styleName: ['emap-measure-node-tooltip', 'emap-measure-tooltip'],
            lengthTipFn,
            areaTipFn,
        });
    },

});

export default component;
